import { render, staticRenderFns } from "./smoke-detector-detail.vue?vue&type=template&id=0106ae22&"
import script from "./smoke-detector-detail.vue?vue&type=script&lang=js&"
export * from "./smoke-detector-detail.vue?vue&type=script&lang=js&"
import style0 from "./smoke-detector-detail.vue?vue&type=style&index=0&id=0106ae22&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports